import { FormProvider } from "react-hook-form";

import { FormRow } from "../../components/FormRow";
import { CustomInput } from "../../components/CustomInput";
import { IUserRoleFormProps } from "./UserRole.model";
import { Button } from "primereact/button";

const UserRoleForm = ({ methods, onSubmit, isEdit }: IUserRoleFormProps) => {
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className="p-fluid">
        <FormRow label="Role Name" name="name">
          <CustomInput name="name" />
        </FormRow>
        <div className="mt-4 flex justify-content-end">
          <Button
            label={isEdit ? "Update role" : "Create role"}
            type="submit"
            className="w-5"
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default UserRoleForm;
